import type { UUID } from '@protector/utils/types';
import type { Config, Report } from '@protector/entities/powerbi-reports/models';

export const PowerBIReportsActionsTypes = {
  LOAD_REPORTS: '[Reports] Load Reports',
  LOAD_REPORTS_SUCCESS: '[Reports] Load Reports Success',
  LOAD_REPORTS_FAILURE: '[Reports] Load Reports Failure',
  LOAD_CONFIG_REPORTS: '[Reports] Load Config Reports',
  LOAD_CONFIG_REPORTS_SUCCESS: '[Reports] Load Config Reports Success',
  LOAD_CONFIG_REPORTS_FAILURE: '[Reports] Load Config Reports Failure'
} as const;

export const LoadReports = (organizationId: UUID, configID: UUID) => {
  return {
    type: PowerBIReportsActionsTypes.LOAD_REPORTS,
    payload: { organizationId, configID }
  };
};

export const LoadReportsSuccess = (report: Report) => {
  return {
    type: PowerBIReportsActionsTypes.LOAD_REPORTS_SUCCESS,
    payload: report
  };
};

export const LoadReportsFailure = (error: string) => {
  return {
    type: PowerBIReportsActionsTypes.LOAD_REPORTS_FAILURE,
    payload: error
  };
};

export const LoadConfigReports = (organizationId: string) => {
  return {
    type: PowerBIReportsActionsTypes.LOAD_CONFIG_REPORTS,
    payload: { organizationId }
  };
};

export const LoadConfigReportsSuccess = (report: Config[]) => {
  return {
    type: PowerBIReportsActionsTypes.LOAD_CONFIG_REPORTS_SUCCESS,
    payload: report
  };
};

export const LoadConfigReportsFailure = (error: string) => {
  return {
    type: PowerBIReportsActionsTypes.LOAD_CONFIG_REPORTS_FAILURE,
    payload: error
  };
};
